import { render, staticRenderFns } from "./CatalogServiceEditor.vue.js?vue&type=template&id=3778adac&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CatalogServiceEditor.vue?vue&type=template&id=3778adac&scoped=true"
import script from "./CatalogServiceEditor.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CatalogServiceEditor.vue?vue&type=script&lang=js"
export * from "./CatalogServiceEditor.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CatalogServiceEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3778adac",
  null
  
)

export default component.exports